import React from "react";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import motazmcqs from "../../Assets/Projects/motazmcqs.png";
import alandalsia from "../../Assets/Projects/alandalsia.png";
import leaf from "../../Assets/Projects/SharedScreednshot.jpg";
import emotion from "../../Assets/Projects/SharedScreef3nshot.jpg";
import editor from "../../Assets/Projects/SharedsdScreenshot.jpg";
import chatify from "../../Assets/Projects/SharedfeScreenshot.jpg";
import suicide from "../../Assets/Projects/SharedS54creenshot.jpg";
import land from "../../Assets/Projects/SharedScreensfhot.jpg";
import bitsOfCode from "../../Assets/Projects/SharedScgf54reenshot.jpg";
import SkyFood from "../../Assets/Projects/skyfood.jpg"; 
import Syrian from "../../Assets/Projects/syrian.jpg";
import Concord from "../../Assets/Projects/concord.jpg";

function Projects() {
  return (
    <div className="project-section" style={{ padding: "70px 0", backgroundColor: "#0d0d0d" }}>
      <Particle />
      <div style={{ width: "90%", margin: "0 auto", maxWidth: "1500px" }}>
        <h1 className="project-heading" style={{ color: "white", textAlign: "center", marginBottom: "20px", fontSize: "3rem" }}>
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white", textAlign: "center", marginBottom: "50px", fontSize: "1.5rem" }}>
          Here are a few projects I’ve worked on recently.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "30px" }}>





          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={motazmcqs}
              isBlog={false}
              title="Dynamic Academic Portal for Customized Exams and Material Management"
              description="This academic platform is designed for university professors to seamlessly upload and manage course materials along with a diverse collection of exams. Each subject hosts multiple exams, and each exam comprises a set of questions, allowing users to choose their preferred exam and customize the number of questions they wish to attempt. With a robust user authentication system that supports both standard registration and Google sign-in, the platform ensures a secure experience. Moreover, an integrated payment gateway facilitates the purchase of premium materials, making it a comprehensive and flexible solution for both educators and students."
              demoLink="https://motazmcqs.com/"
            />
          </div>


          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={alandalsia}
              isBlog={false}
              title="Comprehensive Dashboard and Innovative Digital Reading Experience"
              description="This online library platform offers a state-of-the-art digital reading experience powered by modern technologies.
              It features an intuitive control panel for seamless management of content and user accounts, along with dual
              sign-in functionalities tailored for both readers and administrators. Additionally, the platform includes efficient
              search capabilities and precise categorization of books, ensuring that users can quickly access their desired
              content."
              demoLink="https://alandlyisalib.stylingresume.com/"
              ghLink="https://github.com/Alshoo/lib"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={Concord}
              isBlog={false}
              title="Seamless User Experience and Advanced E-Commerce Features"
              description="
              This e-commerce frontend highlights advanced UI/UX skills with a clean, intuitive interface for electronic
              products. It focuses on smooth interactions, responsive design, and modern animations to elevate user
              engagement.
              "
              ghLink="https://github.com/Alshoo/Seamless-User-Experience-and-Advanced-E-Commerce-Features"
              demoLink="https://concord-mass-fluence.netlify.app/"
            />
          </div>


          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={SkyFood}
              isBlog={false}
              title="Food products factory website"
              description="
              Sky Food is a modern, user-friendly platform showcasing premium food products. It features a clean interface,
              vibrant product displays, multi-language support, and easy access to company details.
              "
              ghLink="https://github.com/Alshoo/Food-products-factory-website-"
              demoLink="https://skyfoodco.com/"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Agency platform"
              description="
              This innovative digital agency platform was built using React and TailwindCSS to deliver a modern, responsive
              user experience with smooth scrolling and parallax effects 
              , It includes a validated contact form, email service integration, SEO optimization, and image and asset
              compression to ensure fast load times and optimal performance across all browsers.
                "
              ghLink="https://github.com/Alshoo/Agency-platform"
              demoLink="https://agancy-platform.netlify.app/"
            />
          </div>

   

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Movie website with fetch API"
              description="
              This platform stands out as one of the best for movie enthusiasts, offering innovative features and leveraging
              modern technologies. Fully responsive design ensures seamless performance across all screen sizes. The Fetch
              API, integrated with Axios, efficiently retrieves movie data. Local storage and session storage are implemented
              to manage user data, including account information during login and personalized movie lists. Designed for an
              enjoyable and user-friendly experience.
              "
              ghLink="https://github.com/Alshoo/Movie-website-with-fetch-API"
              demoLink="https://elsho-group.netlify.app/"
            />
          </div>


          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={Syrian}
              isBlog={false}
              title="Creating a User-Friendly, Multi-Language Platform for Food Lovers"
              description="
              This dynamic platform for a food restaurant and store is designed to enhance user experience and drive sales. A
              multi-language feature ensures global accessibility, while vibrant product displays and engaging recipes create
              an interactive experience. The visually appealing, user-friendly interface boosts engagement and contributes to
              revenue growth.
              "
              ghLink="https://github.com/Alshoo/Creating-a-User-Friendly-Multi-Language-Platform-for-Food-Lovers "
              demoLink="https://www.syriangourmet.com/index"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="eCommerce Website"
              description="
              Afully responsive eCommerce website with secure login, shopping cart, detailed product pages, and a fast
              search bar. It offers an intuitive and engaging user experience.
              "
              ghLink="https://github.com/Alshoo/eCommerce-website"
              demoLink="https://effulgent-mooncake-9c7f1c.netlify.app/"
            />
          </div>




          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Landing page"
              description="Simple Landing page with a simple design and a simple color scheme."
              ghLink="https://github.com/Alshoo/Landing-page"
              demoLink="https://nimble-pegasus-a94d14.netlify.app/"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={land}
              isBlog={false}
              title="Landing page using react"
              description="This is a simple, responsive, and effective project for the user."
              ghLink="https://github.com/Alshoo/Landing-page-using-react"
              demoLink="https://taxpal-elsho-group.netlify.app/"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="covid-19 platform"
              description="Great platform."
              ghLink="https://github.com/Alshoo/covid19"
              demoLink="https://covid19-platform.netlify.app/"
            />
          </div>

          <div className="project-card" style={{ flex: "1 1 450px", maxWidth: "450px" }}>
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="survey platform"
              description="Survey WebPage"
              ghLink="https://github.com/Alshoo/-survey"
              demoLink="https://madmin-43.netlify.app/"
            />
          </div>





        </div>
      </div>
    </div>
  );
}

export default Projects;